import React from 'react';
import { Skeleton, Tooltip, Typography, theme } from 'antd';
import { InboxOutlined, WarningOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { useToken } = theme;

// Tira de indicadores. No hace fetch propio: total y vencidas ya vienen en la
// respuesta del listado, así que pedirlos de nuevo sería una llamada de más.

function KpiTile({ icon: Icon, label, valor, tint, ayuda, loading }) {
  const { token } = useToken();

  return (
    <div
      style={{
        flex: '1 1 200px',
        minWidth: 0,
        border: `1px solid ${token.colorBorder}`,
        borderRadius: token.borderRadiusLG,
        background: token.colorBgContainer,
        boxShadow: token.boxShadowSecondary,
        padding: token.paddingMD,
        display: 'flex',
        alignItems: 'center',
        gap: token.marginSM,
      }}
    >
      <div
        aria-hidden
        style={{
          width: 40,
          height: 40,
          borderRadius: token.borderRadius,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: token.colorFillAlter,
          color: tint,
          flexShrink: 0,
        }}
      >
        <Icon style={{ fontSize: 18 }} />
      </div>
      <div style={{ minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {label}
          </Text>
          {ayuda && (
            <Tooltip title={ayuda}>
              <InfoCircleOutlined style={{ fontSize: 12, color: token.colorTextTertiary }} />
            </Tooltip>
          )}
        </div>
        {loading ? (
          <Skeleton.Button active size="small" style={{ width: 48, height: 24, marginTop: 4 }} />
        ) : (
          <div style={{ fontSize: 24, fontWeight: 600, lineHeight: 1.2, color: tint }}>{valor}</div>
        )}
      </div>
    </div>
  );
}

function SolicitudesDatosKpiStrip({ total, vencidas, loading, filtrando }) {
  const { token } = useToken();

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: token.marginMD }}>
      <KpiTile
        icon={InboxOutlined}
        label={filtrando ? 'Solicitudes que coinciden con el filtro' : 'Solicitudes en total'}
        valor={total}
        tint={token.colorText}
        loading={loading}
      />
      <KpiTile
        icon={WarningOutlined}
        label="Fuera de plazo en todo el sistema"
        valor={vencidas}
        // El rojo sólo cuando hay algo que atender: un 0 en rojo entrena a
        // ignorar el indicador.
        tint={vencidas > 0 ? token.colorError : token.colorTextSecondary}
        loading={loading}
        ayuda="Solicitudes todavía abiertas cuyo plazo legal ya pasó. Este número considera todas las solicitudes del sistema y no cambia al aplicar filtros."
      />
    </div>
  );
}

export default SolicitudesDatosKpiStrip;
